import { Badge } from '@givebutter/primitives/badge';
import { maskPhone } from '@givebutter/util';
import { faBuilding } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { SelectItemWithLabel } from 'components/select';
import { ContactType } from 'constants/contacts';
import { Contact } from 'types/domain';

interface SelectedContactProps {
    contact: SelectItemWithLabel<Contact>;
}
const SelectedContact = ({ contact }: SelectedContactProps) => {
    return (
        <div className={'flex flex-col gap-1'}>
            <p className={'font-medium'}>
                {contact.value?.type === ContactType.Company ? (
                    <span className="flex items-center gap-1">
                        {contact.value?.company_name}
                        <Badge size="sm" color="primary">
                            <FontAwesomeIcon icon={faBuilding} /> Company
                        </Badge>
                    </span>
                ) : (
                    <>
                        {contact.value?.first_name} {contact.value?.last_name}
                    </>
                )}
            </p>
            <p className={'text-gray-600'}>{contact.value?.primary_email}</p>
            <p className={'text-gray-600'}>{maskPhone(contact.value?.primary_phone ?? '')}</p>
        </div>
    );
};

export { SelectedContact };
